__webpack_require__.p = "https://assets.worldcubeassociation.org/nextjs/ef68795120a92776c0d7090cfed7874e081e5df7/_next/";